/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Compliance_BfsgInputs */

const en_landing_compliance_bfsg = /** @type {(inputs: Landing_Compliance_BfsgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BFSG`)
};

const de_landing_compliance_bfsg = /** @type {(inputs: Landing_Compliance_BfsgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BFSG`)
};

const fr_landing_compliance_bfsg = /** @type {(inputs: Landing_Compliance_BfsgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BFSG`)
};

const es_landing_compliance_bfsg = /** @type {(inputs: Landing_Compliance_BfsgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BFSG`)
};

const it_landing_compliance_bfsg = /** @type {(inputs: Landing_Compliance_BfsgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BFSG`)
};

const nl_landing_compliance_bfsg = /** @type {(inputs: Landing_Compliance_BfsgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BFSG`)
};

const pl_landing_compliance_bfsg = /** @type {(inputs: Landing_Compliance_BfsgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BFSG`)
};

const fi_landing_compliance_bfsg = /** @type {(inputs: Landing_Compliance_BfsgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BFSG`)
};

const da_landing_compliance_bfsg = /** @type {(inputs: Landing_Compliance_BfsgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BFSG`)
};

const sv_landing_compliance_bfsg = /** @type {(inputs: Landing_Compliance_BfsgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BFSG`)
};

/**
* | output |
* | --- |
* | "BFSG" |
*
* @param {Landing_Compliance_BfsgInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_compliance_bfsg = /** @type {((inputs?: Landing_Compliance_BfsgInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Compliance_BfsgInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_compliance_bfsg(inputs)
	if (locale === "fr") return fr_landing_compliance_bfsg(inputs)
	if (locale === "es") return es_landing_compliance_bfsg(inputs)
	if (locale === "it") return it_landing_compliance_bfsg(inputs)
	if (locale === "nl") return nl_landing_compliance_bfsg(inputs)
	if (locale === "pl") return pl_landing_compliance_bfsg(inputs)
	if (locale === "fi") return fi_landing_compliance_bfsg(inputs)
	if (locale === "da") return da_landing_compliance_bfsg(inputs)
	if (locale === "sv") return sv_landing_compliance_bfsg(inputs)
	return en_landing_compliance_bfsg(inputs)
});